module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.5461bc53.png";